import BaseModelAPI from '../BaseModelAPI';

export default class PartPurchaseQualityControlConfirmationDetail extends BaseModelAPI {
	static entity = 'partpurchasequalitycontrolconfirmationdetail';
	static entityName = 'partpurchasequalitycontrolconfirmationdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.controlCardId = '';
			this.controlCard = {};
			this.partPurchaseQualityControlConfirmationId = '';
			this.partPurchaseQualityControlConfirmation = {};
			this.thickness = 0;
			this.width = 0;
			this.length = 0;
			this.qty = 0;
			this.karat = false;
			this.retak = false;
			this.goresan = false;
			this.gelombang = false;
			this.burry = false;
			this.benjolan = false;
			this.otherProblem = false;
			this.ngInformation = '';
			this.controlCardStatusId = '';
			this.controlCardStatus = {};
			this.partSpecificationQc = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

	static async showImageEvidence(this_, id) {
		return await this_.$http.get(`${this.entityName}/showImageEvidence/${id}`)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
    }

	static async getQcDetail(this_, id) {
        let _this = this_;
		return this_.$http.get(`${this.entityName}/getQcDetail/${id}`)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
    }

}